import {randomFromArray} from '../../../helpers/random-from-array.js'

//TODO: This file should be re-thought out if team items feature is ever disabled.
export function getThiefPath(casterModel, teamCombatants=[], enemyCombatants=[], casterActions=[]) {

  //NOTE: this path also includes BUGGING. Bugging seems like it could be cursing, but that path is for Statuses.
  //The Thief-ing path involves Items.

  //See if we have valid thief-ing moves
  const validMoves = getValidStealingMoves(casterActions);
  if (!validMoves.length) {
    return null
  }

  //Look at first enemy to get team items
  const sampleTarget = enemyCombatants[0];
  const teamItems = sampleTarget.getTeamItems();
  //If other team has no items, this path is invalid
  if (!teamItems.length) {
    return null
  }

  //Return a random one of our valid moves
  const action = randomFromArray(validMoves);

  //TODO: this block involves the reality of using a feature flag instead of always assuming team items
  // const targets = action.targetType === "opponent-team" //Use full team for targets (based on targetType)
  //   ? enemyCombatants
  //   : [randomFromArray(validEnemyTargets)];

  return {
    actionModel: action,
    casterModel: casterModel,
    targetModels: [...enemyCombatants] //For now, always target all enemies for Stealing moves (TODO: should use feature flag, though)
  }
}

/** Search array of actions for moves that steal items or BUG items or DELETE items */
function getValidStealingMoves(casterActions) {
  return casterActions.filter(action => {
    return action.theftQuantity > 0 || action.sabotageItemQuantity > 0 || action.deleteItemQuantity > 0;
  });
}


// WEBPACK FOOTER //
// ./src/battle/bot-decisions/personality-paths/get-thief-path.js